<template>
  <div class="down">
    <div class="header">
      <div class="container1 head_content">
        <span>收银台</span>
        <span class="duobi">你好，欢迎使用线上支付！</span>
      </div>
    </div>
    <div class="container1" v-if="false">
      <div class="logo">
        <img class="img_item cur_pointer" src="@/assets/img/LOGO.png" alt />
        <div class="test_box">
          <span class="test">多比收银台</span>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="down_box">
        <i class="my_icon el-icon-success"></i>
        <div class="test">
          <span>支付成功，</span>
          <el-button class="second" :loading='loading'>{{loading?'':countDown}}</el-button>
          <span>秒后自动返回商户。</span>
        </div>
      </div>
      <div class="other_links">
        <a href="http://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
          <span class="a_col com_link">{{ hostRecordNo }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: { title: "支付成功" },
  name: "payDown",
  props: {
    isShopView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      countDown: 5,
      interval: null,
      loading: false,
      hostRecordNo: "蜀ICP备20022182号-1",
    };
  },
  mounted() {
    if (this.isShopView)
      this.hostRecordNo = this.$store.state.shopInfo.hostRecordNo;
    this.interval = setInterval(() => {
      if (this.countDown === 0) {
        clearInterval(this.interval);
        this.interval = null;
        // 页面跳转
        let newUrl = this.$router.resolve({
          path: "successPay",
          query: this.$route.query,
        });
        window.open(newUrl.href, "_self");
      } else if (this.countDown === 1) {
        this.countDown--;
        this.loading = true;
      } else {
        this.countDown--;
        this.loading = false;
      }
    }, 1000);
  },
  beforeDestroy() {
    //清除轮询
    clearInterval(this.interval);
    this.interval = null;
  },
};
</script>

<style lang="less" scoped>
.down {
  .header {
    width: 100%;
    min-width: @themeWidth;
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    color: rgba(255, 255, 255, 1);
    background: rgba(26, 26, 26, 1);
    .head_content {
      position: relative;
      .duobi {
        position: absolute;
        right: 0;
      }
    }
  }
  .logo {
    font-size: 14px;
    font-weight: 400;
    color: rgb(103, 109, 112);
    padding: 10px 0;
    display: flex;
    align-items: center;
    .img_item {
      width: auto;
      height: auto;
    }
    .test_box {
      font-size: 16px;
      padding: 0 10px;
      margin-left: 10px;
      height: 40px;
      width: 180px;
      border-left: 1px solid rgb(103, 109, 112);
      position: relative;
      .test {
        position: absolute;
        bottom: 0px;
        left: 10px;
      }
    }
  }
  .content {
    margin-top: 60px;
    height: 300px;
    width: 100%;
    box-sizing: border-box;
    padding-top: 50px;
    background-color: rgb(239, 240, 241);
    .down_box {
      width: 950px;
      height: 84px;
      box-sizing: border-box;
      padding-left: 40px;
      margin: 0 auto;
      background-color: rgb(237, 255, 204);
      display: flex;
      align-items: center;
      .my_icon {
        margin-right: 15px;
        font-size: 40px;
        color: rgb(51, 204, 51);
      }
      .test {
        font-size: 16px;
        color: rgb(60, 60, 60);
        font-weight: bold;
        .second {
          color: #ff0000;
          padding: 0px;
          padding-right: 6px;
          font-size: 16px;
          background-color: rgb(237, 255, 204);
          border: none;
          cursor: text;
        }
      }
    }
    .other_links {
      padding-top: 60px;
      text-align: center;
      .a_col {
        color: #737373;
      }
    }
  }
}
</style>